import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { AuthenticateVehicleDto, ReauthenticateVehicleDto } from './dto/mro-smartcar.dto';
import { MroSmartcarRepository } from './mro-smartcar.repository';
import { AuthenticateLocationResponse, CheckCompatibilityResponse, GetVehicleOdometerResponse } from '../domain/mro-smartcar.model';

@Injectable()
export class MroSmartcarApiService implements MroSmartcarRepository {
    private _http = inject(HttpClient);
    private baseUrl = `${environment.url}${MICROSERVICES.mro_smartcar}`;

    authenticateVehicle(authenticateVehicleDto: AuthenticateVehicleDto): Observable<AuthenticateLocationResponse> {
        const params = new HttpParams()
            .set('rucVehicleId', authenticateVehicleDto.rucVehicleId)
            .set('vin', authenticateVehicleDto.vin)
            .set('redirectURI', authenticateVehicleDto.redirectURI)
            .set('simulated', authenticateVehicleDto.simulated);

        return this._http.get<AuthenticateLocationResponse>(`${this.baseUrl}/auth/location`, { params });
    }

    compatibilityCheck(vin: string, simulated: boolean): Observable<CheckCompatibilityResponse> {
        const params = new HttpParams().set('vin', vin).set('simulated', simulated);
        const options = {
            params,
        };
        return this._http.get<CheckCompatibilityResponse>(`${this.baseUrl}/smartcar-vehicles/compatibility`, options);
    }

    getVehicleOdometer(rucVehicleId: string): Observable<GetVehicleOdometerResponse> {
        return this._http.get<GetVehicleOdometerResponse>(`${this.baseUrl}/admin/odometer?rucVehicleId=${rucVehicleId}`);
    }

    deleteVehicleSmartcar(id: string, miles: number, odometerPhoto: File, feedback: string): Observable<void> {
        const formData = new FormData();
        if(miles !== 0) {
            formData.append('miles', miles.toString());
            formData.append('odometerPhoto', odometerPhoto);
            formData.append('feedback', feedback);
        }
 
        return this._http.request<void>('delete', `${this.baseUrl}/vehicles/${id}`, {
            body: formData
        });
    }

    reauthenticateVehicle(reauthenticateVehicleDto: ReauthenticateVehicleDto): Observable<AuthenticateLocationResponse> {
        const params = new HttpParams()
            .set('vehicleId', reauthenticateVehicleDto.vehicleId)
            .set('redirectURI', reauthenticateVehicleDto.redirectURI);

        return this._http.get<AuthenticateLocationResponse>(`${this.baseUrl}/auth/reauthenticate`, { params });
    }

}
